import { render, staticRenderFns } from "./ComplaintsList.vue?vue&type=template&id=42c42bf0&scoped=true&"
import script from "./ComplaintsList.vue?vue&type=script&lang=js&"
export * from "./ComplaintsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c42bf0",
  null
  
)

export default component.exports